<template>
  <input
    id="searcher"
    class="search-input"
    type="text"
    @input="handleSearch"
    :placeholder="'Buscar...'"
  />
</template>

<script lang="ts">
import { defineComponent, ref, Ref, watch } from "vue";

export default defineComponent({
  name: "AdminSearcher",

  setup(props, context) {
    function handleSearch(event: any) {
      context.emit("update:search", event.target.value);
    }

    return { handleSearch };
  },
});
</script>

<style scoped lang="scss">
@import "src/generalStyle/controls/adminSearcher";
</style>